<div  *ngIf="!load"class="card mb-4">
  <div class="card-body">

      <div class="text-muted small">
        <span>10 últimos clientes que acessaram o <strong>Sistema CDD</strong></span>
      </div>
  </div>

  <div class="px-2">
    <div class="w-100">
     <ol class="list-group list-group-numbered mb-3">
      <li class="list-group-item d-flex justify-content-between align-items-start" *ngFor="let usuarios of usuario">
        <div class="ms-2 me-auto">
          <div class="user"><strong>Cliente: </strong>{{usuarios.nome}}</div>
          <div class="user"><strong>Data do último acesso: </strong>{{usuarios.dataLogin | date: 'fullDate'}}</div>
          <div><strong>Horário do último acesso: </strong>{{usuarios.dataLogin | date: 'hh:mm a'}}</div>
        </div>
      </li>
    </ol>
    </div>
  </div>

</div>

<div *ngIf="load" class="card mb-4" style="display: flex;flex-direction: column;justify-content: center;align-items: center">

  <div class="card-body">

  </div>

  <div class="card-body">
    <div class="spinner-border text-primary" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  </div>

  <div class="card-body">
  </div>

</div>
